"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.productUpdatedEventMapper = exports.productEventMapper = void 0;
var mappers_1 = require("../products/mappers");
exports.productEventMapper = function (item) {
    return __assign(__assign({ _id: item.productId, name: item.name }, mappers_1.mediaMapper(item.media)), { sku: item.sku, visible: item.visible, currency: item.price.currency, price: item.price.price, discountedPrice: item.price.discountedPrice, pricePerUnit: item.price.pricePerUnit, formattedPrice: item.price.formatted.price, formattedDiscountedPrice: item.price.formatted.discountedPrice, formattedPricePerUnit: item.price.formatted.pricePerUnit, productPageUrl: item.productPageUrl.path });
};
exports.productUpdatedEventMapper = function (item) {
    return {
        productId: item.productId,
        updatedFields: item.changedFields,
    };
};
//# sourceMappingURL=productEvent.mapper.js.map